import { render, staticRenderFns } from "./TakipDetailDialog.vue?vue&type=template&id=23277270&scoped=true"
import script from "./TakipDetailDialog.vue?vue&type=script&lang=ts"
export * from "./TakipDetailDialog.vue?vue&type=script&lang=ts"
import style0 from "./TakipDetailDialog.vue?vue&type=style&index=0&id=23277270&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23277270",
  null
  
)

export default component.exports